import { Paginator } from '@app/classes';
import { VacationYtdAdjustment } from '@app/models/payroll/vacation-ytd-adjuster.model';
import { Table } from '@app/modules/table/classes/table.class';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import {
    DateLastAdjustedColumn,
    EmployeeNameColumn,
    EmployeeStatusColumn,
    LastAdjustmentAmountColumn,
    LatestTimeOffYtdBalanceColumn,
} from './columns';

const makeAdjustmentOption: MenuColumnItem = {
    label: 'payroll.vacation-ytds.makeAdjustment',
    event: 'makeAdjustment',
};
export class VacationYtdAdjusterTable extends Table {
    showMenuColumnOptions = true;
    links = true;

    constructor(private disableAdjustmentsBeingMade: boolean) {
        super();
        this.boot();
    }

    setColumns(): void {
        this.columns = [
            new EmployeeNameColumn(),
            new EmployeeStatusColumn(),
            new DateLastAdjustedColumn(),
            new LastAdjustmentAmountColumn(),
            new LatestTimeOffYtdBalanceColumn(),
        ];
    }

    getMenuColumnOptionsForRow(): MenuColumnItem[] {
        if (this.disableAdjustmentsBeingMade) {
            return [];
        }
        return [makeAdjustmentOption];
    }

    getLink(vacationYtdAdjustment: VacationYtdAdjustment): (string | number)[] {
        return ['/payroll/vacation-ytd-adjuster/adjustment-history/' + vacationYtdAdjustment.employee.id];
    }

    setDataSource(): void {
        this.paginator = new Paginator(VacationYtdAdjustment.with('employees'), {
            pageSize: 25,
        });
    }
}
